import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MemberNote } from 'src/app/models/note';
import { MemberNoteEndpoint } from './member-note-endpoint.service';

@Injectable({
    providedIn: 'root'
})
export class MemberNoteService {

    constructor(
        private memberNoteEndpoint: MemberNoteEndpoint,
    ) {}

    getMemberNotes(tenantId: string, memberId: string): Observable<MemberNote[]> {
        return this.memberNoteEndpoint.getMemberNotes(tenantId, memberId);
    }

    async getNotesForMember(tenantId: string, memberId: string): Promise<MemberNote[]> {
        return await this.memberNoteEndpoint.getNotesForMember(tenantId, memberId);
    }
    
    async updateNote(tenantId: string, model: MemberNote): Promise<MemberNote> {
        return await this.memberNoteEndpoint.updateNote(tenantId, model);
    }

    addOrUpdate(tenantId: string, model: MemberNote): Observable<MemberNote> {
        return this.memberNoteEndpoint.addOrUpdate(tenantId, model);
    }

    addOrUpdateFacilityListNotes(facilityId: string, model: MemberNote): Observable<MemberNote> {
        console.log('I am a facility id ->', facilityId);
        return this.memberNoteEndpoint.addOrUpdateFacilityListNotes(facilityId, model);
    }

    setAsPrimary(tenantId: string, memberId: string, addressId: number): Observable<MemberNote[]> {
        return this.memberNoteEndpoint.setAsPrimary(tenantId, memberId, addressId);
    }

    delete(tenantId: string, addressId: number): Observable<boolean> {
        return this.memberNoteEndpoint.delete(tenantId, addressId);
    }

    async deleteNote(tenantId: string, id: number) {
        return await this.memberNoteEndpoint.deleteNote(tenantId, id);
    }

    // getFacilityListMemberNotes(tenantId: string, memberId: string, facilityListNotesId: string) {
    //     return this.memberNoteEndpoint.getFacilityListMemberNotes(tenantId, memberId, facilityListNotesId);
    // }

}


